import React from "react";
import "../MDIs/MDIs.css";
// import MDI_image from "../Assets/MDI_img.jpg";
// import MDI_parts from "../Assets/MDI_parts.webp";

function MDIs() {
  return (
    <>
      <div className="mdi">
      <div className="approved">
            <span >
              "State of the art WHO-GMP, ISO 9001:2008 and NPCB, PIC/S Malaysia
              approved manufacturing facility."
            </span>
            </div>
        <h1 className="mdi-title">
          MDI System
        </h1>
        <div className="container">
        <h2>
          Medisol Pressurized Metered-Dose Inhaler Systems
          
        </h2>
        <div className="row">
          {/* <div className="col-1">
            <img src={MDI_image} alt="" />
          </div> */}
          <div className="col-2">
            <p>
              Since our creation of the first metered-dose inhaler, Medisol has
              been at the forefront of inhaled drug delivery and inhaled
              technologies. Today, pMDIs are relied upon by hundreds of millions
              of people for the treatment of debilitating and life-threatening
              respiratory conditions.
            </p>
          </div>
        </div>

        <h2 >
          pMDI systems are typically comprised of four parts{" "}
        </h2>
        <div className="row">
          <div className="col-3">
            <ul>
              <li>Canister</li>
              <li>Metering Valve</li>
              <li>Spray Orifice</li>
              <li>Plastic Mouthpiece</li>
            </ul>
            <p>
              The system is inherently tamper proof and, as a sealed system,
              minimizes the effect of the environment on the formulation.
              Pressing down on the inhaler releases a measured dose of medicine,
              which is then inhaled into the lungs.<br/><br/> Medisol is continually
              investing and developing new valve technology and has created
              robust designs non-CFC propellants. Medisol also offers an array
              of actuators and canisters that can be customized to fit your pMDI
              system and formulation needs to help ensure the technical success
              of your product. Additionally, we offer features, including
              breath-activated devices and dose counters that improve patient
              experience and help pharmaceutical companies defend their products
              against generic substitution.
            </p>
          </div>
          <div className="col-4">
            {/* <img src={MDI_parts} alt=""  className="mdi-col-4"/> */}
          </div>
        </div>
        </div>
        
      </div>
    </>
  );
}
export default MDIs;
